export function getEnumKeys(enumObject: Record<string, string | number>) {
  return Object.keys(enumObject).filter(key => Number.isNaN(Number(key)));
}

export function getEnumValues<TEnum extends Record<string, number | string>>(
  enumObject: TEnum,
): Array<TEnum[keyof TEnum]> {
  return getEnumKeys(enumObject).map(key => enumObject[key as keyof TEnum]);
}
